var map = {
	"./armor-downgrade.svg": "oj3A",
	"./armor-upgrade.svg": "GOEk",
	"./beer.svg": "3Lt5",
	"./card-exchange.svg": "gKIZ",
	"./chevron-down.svg": "/u3p",
	"./concentration-orb.svg": "ugR6",
	"./fission.svg": "nN+9",
	"./flower-twirl.svg": "wTlg",
	"./gem.svg": "coVg",
	"./gold-nuggets.svg": "lxwL",
	"./info.svg": "25i3",
	"./loader.svg": "xgZ5",
	"./menu.svg": "aw7U",
	"./perpendicular-rings.svg": "TIXe",
	"./shatter.svg": "bPmA",
	"./spiky-eclipse.svg": "xCZS",
	"./striking-balls.svg": "ldqv",
	"./tornado.svg": "VSPW",
	"./up-triangle.svg": "j4pU",
	"./upgrade.svg": "iBYP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UKcq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.svg$
// module id = UKcq
// module chunks = 1